import BaseStore from '../components/BaseStore'

export default {
  extends: BaseStore,
  data () {
    return {
      query: {
        beginTime: '',
        endTime: '',
        dataType: 60
      }
    }
  },
  computed: {
    queryTimeStep: () => 3,
    endTimeDiff: () => 0
  },
  created () {
    let {query} = this

    if (!query.beginTime) {
      let beginTime = new Date()
      beginTime.setDate(beginTime.getDate() - this.queryTimeStep)
      query.beginTime = beginTime.format('YYYY/MM/DD 00:00:00')
    }

    if (!query.endTime) {
      let endTime = new Date()
      endTime.setDate(endTime.getDate() - this.endTimeDiff)
      query.endTime = endTime.format('YYYY/MM/DD 23:59:59')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseDateData.js